/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { inflect, isNotEmpty, isNotNil } from "~/tools";
import { Item, Mode } from "./types";

export const getFirstOptionLabel = (
  selectedOptions: string[],
  options: Item[]
) => {
  return options.find((option) => option.value === selectedOptions[0])?.label;
};

export const getMultiSelectLabel = (
  selectedCount: number,
  name: string,
  pluralName?: string
) => {
  const formatter = inflect(name, pluralName);
  return `${selectedCount} ${formatter(selectedCount)} Selected`;
};

export function getClearSelectionsText(selectedOptions?: string[]) {
  if (isNotNil(selectedOptions) && isNotEmpty(selectedOptions)) {
    return `Clear: ${selectedOptions.length}`;
  }

  return "Clear";
}

export function getSelectedMode(excluded: boolean | undefined) {
  return excluded ? Mode.EXCLUDE : Mode.INCLUDE;
}
